var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { H2, H4 } from "@irati/ui/src/Headings";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Form from "@irati/ui/src/Form";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import Description from "@irati-web/fields/companyValues/Description";
import Header from "@irati-web/fields/companyValues/Header";
import Tag from "@irati-web/fields/companyValues/Tag";
import TrophyField from "@irati-web/fields/trophy";
import padding from "@irati/ui/src/global/padding";
import ErrorText from "@irati/ui/src/ErrorText";
import id from "@irati/utils/id";
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 auto ", ";\n  text-align: center;\n  width: 600px;\n"], ["\n  margin: 0 auto ", ";\n  text-align: center;\n  width: 600px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.three;
});
var StyledH2 = styled(H2)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", " 0 0;\n"], ["\n  margin: ", " 0 0;\n"])), padding.small);
var StyledH4 = styled(H4)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 40px 0 ", ";\n"], ["\n  margin: 40px 0 ", ";\n"])), padding.large);
var StyledValidationButton = styled(ValidationButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 40px;\n"], ["\n  margin-top: 40px;\n"])));
var FIXED_SLIDER_WIDTH_FOR_COMPANY_VALUES = "600px";
var CompanyValuesForm = /** @class */ (function (_super) {
    __extends(CompanyValuesForm, _super);
    function CompanyValuesForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTrophySelect = function (trophy) {
            _this.props.onChangeIcon(trophy);
        };
        return _this;
    }
    CompanyValuesForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, apolloState = _a.apolloState, buttonText = _a.buttonText, companyValue = _a.companyValue, headerText = _a.headerText, intl = _a.intl, onChange = _a.onChange, onSubmit = _a.onSubmit;
        var trophy = {
            trophy: companyValue.icon
        };
        return (React.createElement(StyledDiv, null,
            React.createElement(StyledH2, null,
                React.createElement(FormattedMessage, { id: headerText })),
            React.createElement(StyledH4, null,
                React.createElement(FormattedMessage, { id: "admin.companyValues.form.body" })),
            React.createElement(Form, { form: "create-company-value" },
                React.createElement(Header, { id: id("valueName", this.props), companyValue: companyValue, onChange: onChange }),
                React.createElement(Description, { id: id("valueDescription", this.props), companyValue: companyValue, maxLength: 280, onChange: onChange }),
                React.createElement(TrophyField, { componentToHideOnExpand: function () { return React.createElement(Tag, { id: id("valueTag", _this.props), companyValue: companyValue, onChange: onChange }); }, sliderWidth: FIXED_SLIDER_WIDTH_FOR_COMPANY_VALUES, item: trophy, onChange: this.handleTrophySelect })),
            React.createElement(StyledValidationButton, { apolloState: apolloState, full: true, large: true, loading: intl.formatMessage({ id: "admin.companyValues.form.loading" }), onClick: function () { return onSubmit(companyValue); }, primary: true },
                React.createElement(FormattedMessage, { id: buttonText })),
            apolloState.error && React.createElement(ErrorText, null, apolloState.errorMsg)));
    };
    CompanyValuesForm.defaultProps = {
        id: "companyValuesForm"
    };
    return CompanyValuesForm;
}(Component));
export default injectIntl(CompanyValuesForm);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
